import { bootstrapApplication } from '@angular/platform-browser';
import { APP_ICONS } from '@hunting-nature/shared-ui/helper/icon-registry.const';
import { addIcons } from 'ionicons';
import { cameraOutline, imagesOutline } from 'ionicons/icons';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import '@angular/common/locales/global/de';
// Import cache management utilities for console access
import './app/shared/utils/cache-management.utils';
import { installFetchCache } from './app/shared/utils/fetch-cache.utils';

// Register all icons globally from centralized registry
addIcons({
  'camera-outline': cameraOutline,
  'images-outline': imagesOutline,
  ...APP_ICONS,
});

// Log environment information
console.info(`Starting application in ${environment.production ? 'production' : 'development'} mode`);
console.info(`App: ${environment.appName} (${environment.appId})`);
console.info(`Version: ${environment.version}`);
console.info(`Environment: ${environment.environment}`);

installFetchCache();

bootstrapApplication(AppComponent, appConfig).catch((error: unknown) => console.error('Failed to bootstrap application', error));
